export default "__VITE_ASSET__BGwV6wJr__"